import constant from '../constants/userConstant';

export const userInitialState = {
    getResult: {
        data: null,
        error: null,
        isLoading: false
    },
    addResult: {
        data: null,
        error: null,
        isLoading: false
    },
    updateResult: {
        data: null,
        error: null,
        isLoading: false
    },
}

export function userReducer(state, action) {

    switch (action.type) {

        case constant.GET_REQUEST:
            return {
                ...state,
                getResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.GET_SUCCESS:
            return {
                ...state,
                getResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.GET_FAIL:
            return {
                ...state,
                getResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.ADD_REQUEST:
            return {
                ...state,
                addResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.ADD_SUCCESS:
            return {
                ...state,
                addResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.ADD_FAIL:
            return {
                ...state,
                addResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        case constant.UPDATE_REQUEST:
            return {
                ...state,
                updateResult: {
                    data: null,
                    error: null,
                    isLoading: true
                }
            };

        case constant.UPDATE_SUCCESS:
            return {
                ...state,
                updateResult: {
                    data: action.payload,
                    error: null,
                    isLoading: false
                }
            };

        case constant.UPDATE_FAIL:
            return {
                ...state,
                updateResult: {
                    data: null,
                    error: action.payload,
                    isLoading: false
                }
            };

        default:
            return state;
    }
}

export default userReducer;
